<template>
  <div>
    <!-- <div class="loading" v-if="loading">
        <div class="loader">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div> -->
    <div v-if="show2">
      <StoreNavbar />
      <Home v-if="show" />
      <router-view :key="$route.fullPath"></router-view>

      <StoreFooter />
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import StoreNavbar from "./StoreNavbar";
import Home from "./Home";
import StoreFooter from "./StoreFooter";
import "../../assets/store/js/jquery.imagezoom.js";
// import Products from './Products'
// import Cart from './Cart'
// import ProductDetails from './ProductDetails'
// require('../../assets/store/vendor/jquery/jquery-3.2.1.min.js')
// import '../../assets/store/vendor/animsition/js/animsition.min.js'
// import '../../assets/store/vendor/slick/slick.min.js'
// import '../../assets/store/js/slick-custom.js'

// import '../../assets/store/js/storemain.js'
// import { setTimeout } from 'timers';
export default {
  name: "storehome",
  components: {
    StoreNavbar,
    StoreFooter,
    // Products,
    Home,
  },
  data() {
    return {
      loading: false,
      fetch: false,
      show: true,
      show2: false,
      shops: [],
      secondaryDatabase: {},
      //   categoriesList: [],
      //   shops: []
    };
  },

  //   watch: {

  //       shops () {
  //          if(this.shops[0].shoptype == 'Fashion'){
  //           this.categoriesList = fashion
  //       }
  //       if(this.shops[0].shoptype == 'Elec'){
  //           this.categoriesList = mobiles
  //       }
  //       }
  //   },

  //    beforeRouteEnter (to, from, next) {
  //     try{
  //         firebase.app(to.params.storename).firestore()
  //         console.log('secondaryDB Exsisted')
  //         next()
  //     }catch(err){
  //         db.collection('shops').where('owner', '==', to.params.storename).onSnapshot(querySnapshot => {
  //         var shops = []
  //         querySnapshot.forEach(doc => {
  //         const data = {
  //         'id' : doc.id,
  //         'shoptype' : doc.data().shoptype,
  //         'visits': doc.data().visits,
  //         'loc': doc.data().location,
  //         'categories':doc.data().categories,
  //         'plan':doc.data().plan,
  //         'cat': doc.data().cat,
  //         'details': doc.data().details,
  //         'config': doc.data().config

  //         }
  //         shops.push(data)
  //         console.log(shops[0].config)
  //         console.log(shops[0].id)
  //         var secondaryAppConfig = shops[0].config
  //         var secondaryApp = firebase.initializeApp(secondaryAppConfig, to.params.storename)
  //         var secondaryDatabase = secondaryApp.firestore()
  //         console.log('var secondaryDatabase', secondaryDatabase)
  //         setTimeout(() => {
  //             next( vm =>{
  //                 vm.secondaryDatabase = secondaryDatabase
  //                 console.log('vmsecondaryDB', vm.secondaryDatabase)
  //                 vm.$store.state.secondaryDatabase = secondaryDatabase
  //                 vm.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
  //                 vm.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
  //                 //console.log("Woohoo! Multi-Tab Persistence!");
  //                 });
  //                 console.log('secondaryDB', vm.$store.state.secondaryDatabase)
  //                 })
  //         },100)
  //     })
  //     })
  //     }
  //    },

  watch: {
    $route() {
      this.show2 = false;
      try {
        firebase.app(this.$route.params.storename);
        this.$store.state.secondaryDatabase = firebase
          .app(this.$route.params.storename)
          .firestore();
        this.show2 = true;
        //console.log('secondaryDB Exsits', this.$store.state.secondaryDatabase)
      } catch (err) {
        db.collection("shops")
          .where("owner", "==", this.$route.params.storename)
          .onSnapshot((querySnapshot) => {
            var shops = [];
            querySnapshot.forEach((doc) => {
              const data = {
                id: doc.id,
                name: doc.data().name,
                shoptype: doc.data().shoptype,
                visits: doc.data().visits,
                loc: doc.data().location,
                categories: doc.data().categories,
                homeimg: doc.data().homeimg,
                plan: doc.data().plan,
                cat: doc.data().cat,
                details: doc.data().details,
                config: doc.data().config,
                noDB: doc.data().noDB
              };
              shops.push(data);
              //console.log(shops[0].config)
              //console.log(shops[0].id)
              if (!shops[0].noDB) { // having own db
                var secondaryAppConfig = shops[0].config;
                var secondary = firebase.initializeApp(
                  secondaryAppConfig,
                  this.$route.params.storename
                );
                this.$store.state.secondaryDatabase = secondary.firestore();
                // this.$store.state.secondaryApp = this.$route.params.storename
                this.$store.state.secondaryDatabase.settings({
                  timestampsInSnapshots: true,
                });
                this.$store.state.secondaryDatabase
                  .enablePersistence({ synchronizeTabs: true })
                  .then(() => {
                    //console.log("Woohoo! Multi-Tab Persistence!");
                  });
                this.show2 = true;
              } else {
                this.$store.state.secondaryDatabase = db;
                this.$store.state.noDB = true;
                this.show2 = true;
              }
              //console.log('secondaryDB', this.$store.state.secondaryDatabase)
            });
          });
      }
      if (this.$route.name != "storehome") {
        this.show = false;
      } else if (this.$route.name == "storehome") {
        this.show = true;
      }
    },
  },
  mounted() {
    // console.log('secondaryDB 1', this.$store.state.secondaryDatabase)
    // setTimeout(() => console.log('secondaryDB time out', this.$store.state.secondaryDatabase),5000)
    // console.log('secondaryDB 3', this.$store.state.secondaryDatabase)
    if (this.$route.name != "storehome") {
      this.show = false;
    } else if (this.$route.name == "storehome") {
      this.show = true;
    }
  },
  beforeCreate() {
    // db.collection('shops').where('owner', '==', this.$route.params.storename).onSnapshot(querySnapshot => {
    // var shops = []
    // querySnapshot.forEach(doc => {
    // const data = {
    // 'id' : doc.id,
    // 'shoptype' : doc.data().shoptype,
    // 'visits': doc.data().visits,
    // 'loc': doc.data().location,
    // 'categories':doc.data().categories,
    // 'plan':doc.data().plan,
    // 'cat': doc.data().cat,
    // 'details': doc.data().details,
    // 'config': doc.data().config
    // }
    // shops.push(data)
    // console.log(shops[0].config)
    // console.log(shops[0].id)
    // var secondaryAppConfig = shops[0].config
    //  var secondary = firebase.initializeApp(secondaryAppConfig, this.$route.params.storename)
    // this.$store.state.secondaryDatabase = secondary.firestore()
    // this.$store.state.secondaryApp = this.$route.params.storename
    // this.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
    // this.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
    //     //console.log("Woohoo! Multi-Tab Persistence!");
    // });
    // console.log('secondaryDB', this.$store.state.secondaryDatabase)
    // })
    // })
  },
  created() {
    //   this.loading = true
    //    this.$store.commit('getAppConfig',this.$route.params.storename)
    //    setTimeout(()=> {
    //        this.loading = false
    //        this.show2 = true
    //     }, 1000)

    try {
      firebase.app(this.$route.params.storename);
      this.$store.state.secondaryDatabase = firebase
        .app(this.$route.params.storename)
        .firestore();
      this.show2 = true;
      //console.log('secondaryDB Exsits', this.$store.state.secondaryDatabase)
    } catch (err) {
      db.collection("shops")
        .where("owner", "==", this.$route.params.storename)
        .get()
        .then((querySnapshot) => {
          var shops = [];
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              name: doc.data().name,
              shoptype: doc.data().shoptype,
              visits: doc.data().visits,
              loc: doc.data().location,
              categories: doc.data().categories,
              homeimg: doc.data().homeimg,
              plan: doc.data().plan,
              cat: doc.data().cat,
              details: doc.data().details,
              config: doc.data().config,
              noDB: doc.data().noDB
            };
            shops.push(data);
            //console.log(shops[0].config)
            //console.log(shops[0].id)
            if (!shops[0].noDB) { // having own db
              if (shops[0].config) {
                var secondaryAppConfig = shops[0].config;
                var secondary = firebase.initializeApp(
                  secondaryAppConfig,
                  this.$route.params.storename
                );
                this.$store.state.secondaryDatabase = secondary.firestore();
                // this.$store.state.secondaryApp = this.$route.params.storename
                this.$store.state.secondaryDatabase.settings({
                  timestampsInSnapshots: true,
                });
                this.$store.state.secondaryDatabase
                  .enablePersistence({ synchronizeTabs: true })
                  .then(() => {
                    //console.log("Woohoo! Multi-Tab Persistence!");
                  });
                this.show2 = true;
              }
              //console.log('secondaryDB', this.$store.state.secondaryDatabase)
            } else {
              //console.log('shop config', shops[0].config)
              this.$store.state.secondaryDatabase = db;
                this.$store.state.noDB = true;
              this.show2 = true;
            }
          });
        });
    }
    if (this.$route.name != "storehome") {
      this.show = false;
    } else if (this.$route.name == "storehome") {
      this.show = true;
    }
  },
};
</script>

<style scoped>
@import url("~@/assets/main/css/loading.css");
/* @import url('~@/assets/store/fonts/font-awesome-4.7.0/css/font-awesome.min.css'); */
/* @import url('~@/assets/store/fonts/iconic/css/material-design-iconic-font.min.css'); */
/* @import url('~@/assets/store/fonts/linearicons-v1.0.0/icon-font.min.css'); */
/* @import url('~@/assets/store/vendor/animate/animate.css');
     @import url('~@/assets/store/vendor/css-hamburgers/hamburgers.min.css');
     @import url('~@/assets/store/vendor/animsition/css/animsition.min.css');
     @import url('~@/assets/store/vendor/slick/slick.css');
     @import url('~@/assets/store/vendor/MagnificPopup/magnific-popup.css'); */
@import url("~@/assets/store/css/util.css");
@import url("~@/assets/store/css/main.css");
@import url("~@/assets/store/css/cat.css");
</style>




// WEBPACK FOOTER //
// src/components/store/StoreHome.vue